export default {"src":"/_next/static/media/favicon_48x48.5c201d3c.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};